import { Field, Formik } from "formik";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import Button from "_shared/components/Button/Button";
import InputField from "../../_shared/components/InputField/InputField";
import Loading from "../../_shared/components/Loading/Loading";
import { useAuth, withAuth } from "../../_shared/contexts/AuthContext";
import { useModal } from "../../_shared/contexts/ModalContext";
import "./Login.scss";

interface Props {
  signIn: (
    _username: string,
    _password: string,
    _rememberMe: boolean,
  ) => Promise<void>;
}

const initialValues = { username: "", password: "", rememberMe: true };

export const Login: React.FC<Props> = ({ signIn }) => {
  const { isAuthenticating, savedUser } = useAuth();
  const { onErrorMsg } = useModal();
  const location = useLocation();

  return (
    <div id="login-page">
      <div className="card">
        <div>
          <h2 className="welcome-back-text">Welcome back</h2>
          <Formik
            // TODO: validation is handled in submit because of the current error modal system
            onSubmit={async (values) => {
              if (!values.username) {
                return onErrorMsg("You must enter a username.");
              } else if (!values.password) {
                return onErrorMsg("You must enter a password.");
              }
              signIn(values.username, values.password, values.rememberMe);
            }}
            enableReinitialize
            initialValues={
              savedUser
                ? {
                  username: savedUser,
                  password: "savedpassword",
                  rememberMe: true,
                }
                : initialValues
            }
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit} style={{ width: 355 }}>
                <div className="input-container">
                  <InputField name="username" label="Username" />
                </div>
                <div className="input-container">
                  <InputField
                    type="password"
                    name="password"
                    label="Password"
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    margin: "7px 0px",
                  }}
                >
                  <Link
                    to="/reset"
                    className="forgot-password-link"
                    style={{ margin: 0, marginTop: 5 }}
                  >
                    Forgot your password?
                  </Link>
                  <div className="remember-me">
                    <Field type="checkbox" name="rememberMe" id="rememberMe" />
                    <label htmlFor="rememberMe" style={{ marginTop: 5 }}>
                      Remember Me
                    </label>
                  </div>
                </div>
                <Button data-testid="button-login" type="submit" fullWidth>
                  Log In
                </Button>
              </form>
            )}
          </Formik>
          <div className="dont-have-account-text">
            <div className="justify-center">Don't have an account yet?</div>
            <a target="_blank" href="https://longbow.pro/signup" className="signup-link justify-center">
              SIGN UP
            </a>
            {location.search.includes("42m") && (
              <>
                <div className="justify-center" style={{ marginTop: 10 }}>
                  Are you subscribed to the{" "}
                  <img
                    style={{
                      height: 20,
                      width: 20,
                      marginLeft: 4,
                      marginTop: -3,
                      marginRight: 2,
                    }}
                    src="42macro_tabs.svg"
                  />
                  Macro Bundle?
                </div>
                <Link to="/42macro" className="signup-link justify-center">
                  CLAIM LONGBOW PLUS ACCESS
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
      {isAuthenticating && <Loading message="Signing in..." />}
    </div>
  );
};

export default withAuth(Login);
